import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Viewdetail(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4 5.72C4 3.667 5.637 2 7.657 2h8.686C18.363 2 20 3.666 20 5.72v12.56c0 2.054-1.637 3.72-3.657 3.72H7.657C5.637 22 4 20.334 4 18.28V5.72zm3.657-1.86c-1.01 0-1.828.833-1.828 1.86v12.56c0 1.027.818 1.86 1.828 1.86h8.686c1.01 0 1.828-.833 1.828-1.86V5.72c0-1.027-.818-1.86-1.828-1.86H7.657z",
    clipRule: "evenodd"
  }), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M7.559 7.814c0-.514.418-.93.935-.93h4.675c.517 0 .935.416.935.93 0 .513-.418.93-.935.93H8.494a.933.933 0 01-.935-.93zm0 7.674c0-.513.419-.93.935-.93h3.74c.517 0 .935.417.935.93 0 .514-.418.93-.935.93h-3.74a.933.933 0 01-.935-.93z",
    clipRule: "evenodd"
  }), React.createElement(Path, {
    d: "M7.56 11.535c0-.514.418-.93.934-.93h7.48c.517 0 .936.416.936.93s-.419.93-.935.93h-7.48a.933.933 0 01-.936-.93z"
  }));
}

export default Viewdetail;